exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://s3.amazonaws.com/gfr-assets/ui-kit/css/main.css);", ""]);

// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /codebuild/output/src4156872633/src/~/css-loader?{"sourceMap":false,"importLoaders":1}!/codebuild/output/src4156872633/src/~/postcss-loader?{"ident":"postcss"}!/codebuild/output/src4156872633/src/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/styles.css
// module chunks = 2